<script lang="ts">
    import {authFetch} from "../Auth";
    import type {UserData} from "../Types";

    export let params: {
        userId: string
    }
    let filter = {
        user_id: ""
    }
    $: {
        filter.user_id = params.userId
        update()
    }
    let userInfoPromise: Promise<any>
    let userInfo: UserData | null = null;

    async function loadUserInfo() {
        let response = await authFetch(`user/info/${filter.user_id}`, {
            method: 'GET',
        })
        if (response.ok) {
            userInfo = await response.json();
        } else {
            alert(response.statusText)
        }
    }
    function update(){
        userInfoPromise = loadUserInfo()
    }
</script>

<div class="container-fluid mt-2">
    {#await userInfoPromise}
        <div class="text-center">
            <div class="spinner-grow"></div>
        </div>
    {:then _}
        <table class="table table-bordered table-sm">
            <tbody>
                <tr>
                    <th>telegram_id</th>
                    <td>{userInfo.telegram_id}</td>
                </tr>
                <tr>
                    <th>phone</th>
                    <td>{userInfo.phone}</td>
                </tr>
                <tr>
                    <th>Назва цілі</th>
                    <th>
                        {#each userInfo.names as user_name}
                            <button class="btn btn-sm btn-outline-dark m-1 disabled">{user_name.name}</button>
                        {/each}
                    </th>
                </tr>
            </tbody>
        </table>
        <table class="table table-bordered table-sm">
            <thead>
            <tr>
                <th colspan="100" class="text-center">Сесії</th>
            </tr>
            <tr>
                <th>Назва додатку</th>
                <th>Версія додатку</th>
                <th>Платформа</th>
                <th>Модель пристрою</th>
                <th>Версія системи</th>
                <th>Дата входу</th>
                <th>Дата останнього викор</th>
                <th>IP</th>
                <th>Країна</th>
                <th>Регіон</th>
            </tr>
            </thead>
            <tbody>
            {#if userInfo.active_sessions.length === 0}
                <tr>
                    <th colspan="100" class="text-center">Немає інформації про сесії</th>
                </tr>
            {/if}
            {#each userInfo.active_sessions as active_session}
                {#if active_session.is_current === 0}
                    <tr>
                        <td>{active_session.telegram_application_name}</td>
                        <td>{active_session.telegram_application_version}</td>
                        <td>{active_session.platform}</td>
                        <td>{active_session.device_model}</td>
                        <td>{active_session.system_version}</td>
                        <td>{active_session.log_in_date}</td>
                        <td>{active_session.last_active_date}</td>
                        <td>{active_session.ip}</td>
                        <td>{active_session.country}</td>
                        <td>{active_session.region}</td>
                    </tr>
                {/if}
            {/each}
            </tbody>
        </table>
    {:catch error}
        <div class="alert alert-danger">
            {error}<br/>
            Не вдалося завантажити данні контакта {JSON.stringify(params)}
        </div>
    {/await}
</div>


